import { useEffect, useContext, useState } from "react";
import QlikObject from "components/QlikObject";
import GlobalContext from "GlobalContext";
import TabOverview from "./tab_overview";
import TabRegional from "./tab_regional";
import TabLocal from "./tab_local";
import TabDynamics from "./tab_dynamics";
import FlaticonIcon from "components/FlaticonIcon";


export default function Metrics({ title, appDisclaimer, pageTitle, ExportChartFootnote, menuItemsStrings, onPageTitle, navbarObjectId, isMobile }) {
  useEffect(() => {
    document.title = `${pageTitle} - ${title}`;
    onPageTitle && onPageTitle(title);
  }, [pageTitle, title, onPageTitle]);

  const { app } = useContext(GlobalContext);
  const [err, setError] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [FilterHeightInvestmentProjects, setFilterHeight] = useState(688);

  // Tab definitions — labels can be pulled from menuItemsStrings if translated
  const TABS = [
    { key: "overview", icon: "dashboard-monitor", label: menuItemsStrings.tabMetricsOverview || "Огляд" },
    { key: "regional", icon: "region-pin-alt", label: menuItemsStrings.tabMetricsRegional || "Регіональний рівень" },
    { key: "local",    icon: "land-layer-location", label: menuItemsStrings.tabMetricsLocal    || "Локальний рівень" },
    /*{ key: "dynamics", icon: "chart-line-up", label: menuItemsStrings.tabMetricsDynamics || "Динаміка" },*/
  ];
  const [activeTab, setActiveTab] = useState(TABS[0].key);

  useEffect(() => {
    app.model.waitForOpen.promise.then(() => {
      setTimeout(async () => {
        app.model.enigmaModel.evaluate("$(=count({1}distinct [_col_id_investmentprojects]))").then(async (reply) => {
          const InvestmentProjectsNumberOfFilterRows = reply * 27 + 40;
          console.log('InvestmentProjectsNumberOfFilterRows/Number of rows: ', InvestmentProjectsNumberOfFilterRows);
          setFilterHeight(InvestmentProjectsNumberOfFilterRows);
        }).catch(err => {
          if (!err) setError(err);
        });
      }, 500);
    });
  }, [app, err]);

  return (
    <section className="content fillpage spp-tabbed">
      <div className="content-header spp-fixed-header">
        <div className="mobile-page-header">
          <h4 className="mobile-page-title">{title}</h4>
          {navbarObjectId && isMobile && (
            <div className="mobile-page-object">
              <QlikObject
                key={`mobile-${navbarObjectId}`}
                id={navbarObjectId}
                height="30px"
                showLoader={false}
              />
            </div>
          )}
        </div>
        {/* Tab selector */}
        <div className="row mb-2">
          <div className="col-12">
            <ul className="nav nav-tabs spp-tabs">
              {TABS.map((tab) => (
                <li className="nav-item" key={tab.key}>
                  <button
                    type="button"
                    className={`nav-link ${activeTab === tab.key ? "active" : ""}`}
                    onClick={() => setActiveTab(tab.key)}
                  >
                    {tab.icon && (
                      <FlaticonIcon icon={tab.icon} size={16} className="tab-icon" />
                    )}
                    {tab.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Tab body — conditionally mounted so off-tab Qlik objects are closed */}
      {activeTab === "overview" && (
        <TabOverview
          app={app}
          menuItemsStrings={menuItemsStrings}
          ExportChartFootnote={ExportChartFootnote}
        />
      )}

      {activeTab === "regional" && (
        <TabRegional
          app={app}
          menuItemsStrings={menuItemsStrings}
          ExportChartFootnote={ExportChartFootnote}
        />
      )}

      {activeTab === "local" && (
        <TabLocal
          app={app}
          menuItemsStrings={menuItemsStrings}
          ExportChartFootnote={ExportChartFootnote}
        />
      )}

      {activeTab === "dynamics" && (
        <TabDynamics
          app={app}
          menuItemsStrings={menuItemsStrings}
          ExportChartFootnote={ExportChartFootnote}
        />
      )}

      {/* Page-level hidden export helper (shared across tabs) */}
      <div className="container-fluid">
        <div className="row m-0">
          <div className="col-md-2 col-sm-3 col-2">
            <QlikObject
              id="c4b4d7f1-e6f8-422f-a928-75a8b6029584"
              height="0px"
              showLoader={false}
            />
          </div>
        </div>
      </div>
    </section>
  );
}